import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Typography,
  Button,
} from "@material-tailwind/react";
import "../../styles/cardStyles.css";
import { Link } from "react-router";
import TreatmentCategoriesAccordion from "../accordion/CategoriesAccordion";

const CategoryCard = ({ categoryDetails }) => {
  return (
    <Card className="shadow-lg hover:shadow-lg rounded-none hover:shadow-black/30 transition-shadow duration-500 data-card">
      <CardHeader className="relative mt-3 h-60 rounded-none">
        <img
          src={categoryDetails.src}
          alt={categoryDetails.alt}
          className="object-cover w-full h-full card-thumbnail"
        />
      </CardHeader>
      <CardBody>
        <Typography
          variant="h5"
          color="blue-gray"
          className="text_CormorantGaramond-Regular text-2xl"
        >
          {categoryDetails.title}
        </Typography>
        <Typography className="leading-tight description_AlegreyaSans-Light mb-1">
          <p className="line-clamp-3">{categoryDetails.description}</p>
        </Typography>

        {categoryDetails.equipment &&
          Array.isArray(categoryDetails.equipment) && (
            <TreatmentCategoriesAccordion
              AccordionData={categoryDetails.equipment}
            />
          )}
      </CardBody>
      <CardFooter className="pt-0">
        <Link to={`/Treatments/${categoryDetails.title}`}>
          <Button className="text_OpenSans-VariableFont_wdth">View Treatments</Button>
        </Link>
      </CardFooter>
    </Card>
  );
};

export default CategoryCard;
